import { CONFIG } from '../config.js';

export function eraFromTemperature(T, config = CONFIG) {
  if (T > config.SCORCHING_T) return { key: 'scorching', label: '乱纪元·炎热' };
  if (T < config.FREEZING_T) return { key: 'freezing', label: '乱纪元·极寒' };
  return { key: 'stable', label: '恒纪元' };
}
